const ACTIONS = [
  ['bold', 'bold'],
  ['italic', 'italic'],
  ['underline', 'underline'],
  ['title', 'heading', false],
  ['quotes', 'reference'],
  ['chains', 'link'],
  ['picture', 'image'],
  ['dash', 'strikethrough'],
  ['ul', 'ul'],
  ['ol', 'ol'],
  ['code', 'code'],
];

export const MARKDOWN_ACTIONS = ACTIONS.map(([icon, action, custom = true]) => ({
  custom,
  icon,
  action,
  tooltip: action,
  color: 'primary',
  aria: action,
}));
